import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BankTransferLogResponse } from '../components/pages/dashboard/bi-transfers/bi-transfer-history/bi-transfer-history.component';
import { ResponseObject } from '../models/response-object.model';
@Injectable({
  providedIn: 'root'
})
export class BixmlService {
  private URL = environment.api + "api/bixml";

  constructor(
		private http: HttpClient
	) { }

  generateXml(request: any) {
    return this.http.post(`${this.URL}/xml`, request, {
      responseType: 'blob'
    });
  }

  sendRequestS3(request: any) {
    return this.http.post(`${this.URL}/xml/s3`, request);
  }

  getHistory(params: any): Observable<{ total: number; data: BankTransferLogResponse[] }> {
    let httpParams = new HttpParams();
    if (params.startDate) httpParams = httpParams.set('startDate', params.startDate);
    if (params.endDate) httpParams = httpParams.set('endDate', params.endDate);
    //httpParams = httpParams.set('page', params.page).set('size', params.size);

    return this.http.get<{ total: number; data: BankTransferLogResponse[] }>(
      `${this.URL}/xml/history`,
      { params: httpParams }
    );
  }

  downloadTransferPdf(idTransaction: number): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(
      `${this.URL}/report/transaction/${idTransaction}/pdf`
    );
  }



}
